import api from "./axios";

export const restoreAIConversation = (id) => api.get(`/ai/conversations/${encodeURIComponent(id)}`);

export const askAI = (
  message,
  {
    confirmAction = false,
    idempotencyKey = null,
    conversationId = null,
    taskId = null,
    taskVersion = null,
    taskHash = null,
    pageContext = null,
    entitySelection = null,
    reorderEdit = null,
  } = {},
) =>
  api.post("/ai/chat", {
    message,
    confirm_action: confirmAction,
    idempotency_key: idempotencyKey,
    conversation_id: conversationId,
    task_id: taskId,
    task_version: taskVersion,
    task_hash: taskHash,
    ...(pageContext ? { page_context: pageContext } : {}),
    ...(entitySelection ? { entity_selection: entitySelection } : {}),
    ...(reorderEdit ? { reorder_edit: reorderEdit } : {}),
  });
